// extracted by mini-css-extract-plugin
export default {"hideOnPrint":"Ks8aFmZLjassYPZUqEac","showOnPrint":"Kkcc4_Z2LwGFvnrkmuUH","scrollDetector":"fUyCRdvjPuiJ_79DyH90"};